// Enum for Checkware Task type IDs
export enum CheckwareTaskTypes {
	// Only one recipient needs to complete a task
	OneRecipientCompletesTask = "532A1AE3-A05B-4173-BC11-B26604BA2065",
	// All recipients need to complete a task
	AllRecipientCompletesTask = "95B25C80-863C-4307-A099-F944BBDEC287"
}
